var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLts2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 86,
    viewBox: "0 0 107 86",
    fill: "none",
    id: "svg28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_6444)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.3061 78.0546V78.0546C87.3061 63.9207 75.8483 52.4629 61.7144 52.4629H44.6532C30.5193 52.4629 19.0615 63.9207 19.0615 78.0546V78.0546",
    stroke: "#DDA34E",
    strokeWidth: 2.4483,
    id: "path1",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.7769,
    y: 66.6453,
    width: 3.40171,
    height: 4.86392,
    rx: 1.70085,
    transform: "rotate(25.5145 71.7769 66.6453)",
    fill: "#F8F8F8",
    stroke: "#DDA34E",
    strokeWidth: 1.85548,
    id: "rect1",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.40171,
    height: 4.86392,
    rx: 1.70085,
    transform: "matrix(-0.902476 0.43074 0.43074 0.902476 34.1433 66.6453)",
    fill: "#F8F8F8",
    stroke: "#DDA34E",
    strokeWidth: 1.85548,
    id: "rect2",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5338 74.107L74.5088 73.161C73.8485 72.5517 73.7196 71.5569 74.2029 70.7995L76.2206 67.6369C76.3162 67.487 76.3898 67.3242 76.4391 67.1534L76.931 65.4489C77.1096 64.83 77.5964 64.3481 78.2171 64.1756L82.4633 62.9962C82.9659 62.8566 83.504 62.9349 83.9458 63.2121L90.0681 67.052C90.299 67.1969 90.4951 67.3907 90.6426 67.6199L93.048 71.3584C93.3782 71.8715 93.4349 72.5143 93.1998 73.0774L91.7545 76.5381C91.6613 76.7613 91.5254 76.9641 91.3544 77.1351L89.6325 78.857L87.7236 80.7659C86.9721 81.5174 85.7535 81.5174 85.002 80.7659C84.2504 80.0143 84.2504 78.7958 85.002 78.0442L84.3198 78.7264C83.5682 79.478 82.3497 79.478 81.5981 78.7264C80.8466 77.9748 80.8466 76.7563 81.5981 76.0047L81.3742 76.2287C80.6226 76.9803 79.4041 76.9803 78.6525 76.2287C77.901 75.4771 78.4041 73.7555 79.1557 73.0039L78.1042 74.0554C77.4 74.7595 76.2656 74.7823 75.5338 74.107Z",
    fill: "#F8F8F8",
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.5088 73.161L75.1379 72.4792L75.1379 72.4792L74.5088 73.161ZM75.5338 74.107L74.9046 74.7887L74.9046 74.7887L75.5338 74.107ZM80.8116 70.036C81.1739 69.6737 81.7613 69.6737 82.1236 70.036C82.4859 70.3983 82.4859 70.9857 82.1236 71.348L80.8116 70.036ZM78.2171 64.1756L77.9688 63.2818L77.9688 63.2818L78.2171 64.1756ZM82.4633 62.9962L82.215 62.1023L82.215 62.1023L82.4633 62.9962ZM93.1998 73.0774L94.0559 73.4349L93.1998 73.0774ZM91.7545 76.5381L90.8985 76.1806L90.8985 76.1806L91.7545 76.5381ZM83.5332 72.7576C83.8955 72.3953 84.4829 72.3953 84.8452 72.7576C85.2075 73.1199 85.2075 73.7074 84.8452 74.0697L83.5332 72.7576ZM86.2549 75.4793C86.6172 75.117 87.2046 75.117 87.5669 75.4793C87.9292 75.8416 87.9292 76.429 87.5669 76.7913L86.2549 75.4793ZM89.6325 78.857L88.9765 78.2009L88.9765 78.2009L89.6325 78.857ZM91.3544 77.1351L92.0104 77.7911L92.0104 77.7911L91.3544 77.1351ZM83.9458 63.2121L83.4529 63.998L83.9458 63.2121ZM90.0681 67.052L90.561 66.2661L90.0681 67.052ZM90.6426 67.6199L91.4228 67.1179L91.4228 67.1179L90.6426 67.6199ZM93.048 71.3584L92.2678 71.8603L93.048 71.3584ZM76.931 65.4489L77.8224 65.7062L77.8224 65.7062L76.931 65.4489ZM76.4391 67.1534L77.3305 67.4106L77.3304 67.4106L76.4391 67.1534ZM76.2206 67.6369L77.0027 68.1358L77.0027 68.1359L76.2206 67.6369ZM74.2029 70.7995L74.985 71.2985L74.985 71.2985L74.2029 70.7995ZM75.1379 72.4792L76.163 73.4252L74.9046 74.7887L73.8796 73.8428L75.1379 72.4792ZM77.4482 73.3994L78.4997 72.3479L79.8117 73.6599L78.7602 74.7114L77.4482 73.3994ZM78.4997 72.3479L80.8116 70.036L82.1236 71.348L79.8117 73.6599L78.4997 72.3479ZM77.9688 63.2818L82.215 62.1023L82.7116 63.8901L78.4654 65.0695L77.9688 63.2818ZM94.0559 73.4349L92.6106 76.8956L90.8985 76.1806L92.3437 72.7199L94.0559 73.4349ZM80.7182 75.5727L80.9421 75.3487L82.2541 76.6607L82.0302 76.8847L80.7182 75.5727ZM80.9421 75.3487L83.5332 72.7576L84.8452 74.0697L82.2541 76.6607L80.9421 75.3487ZM79.3085 75.5727C79.6978 75.9619 80.3289 75.9619 80.7182 75.5727L82.0302 76.8847C80.9163 77.9986 79.1104 77.9986 77.9965 76.8847L79.3085 75.5727ZM79.8117 73.6599C79.5862 73.8854 79.3456 74.3291 79.2495 74.8012C79.1464 75.308 79.2631 75.5273 79.3085 75.5727L77.9965 76.8847C77.2904 76.1786 77.2828 75.1612 77.4313 74.4314C77.5868 73.6669 77.9736 72.8739 78.4997 72.3479L79.8117 73.6599ZM83.6638 78.0704L84.346 77.3882L85.658 78.7002L84.9758 79.3824L83.6638 78.0704ZM84.346 77.3882L86.2549 75.4793L87.5669 76.7913L85.658 78.7002L84.346 77.3882ZM82.2541 78.0704C82.6434 78.4596 83.2745 78.4596 83.6638 78.0704L84.9758 79.3824C83.8619 80.4963 82.056 80.4963 80.9421 79.3824L82.2541 78.0704ZM82.2541 76.6607C81.8649 77.05 81.8649 77.6811 82.2541 78.0704L80.9421 79.3824C79.8283 78.2685 79.8283 76.4626 80.9421 75.3487L82.2541 76.6607ZM85.658 80.1098C86.0473 80.4991 86.6784 80.4991 87.0676 80.1098L88.3797 81.4219C87.2658 82.5357 85.4598 82.5357 84.346 81.4219L85.658 80.1098ZM85.658 78.7002C85.2687 79.0895 85.2687 79.7206 85.658 80.1098L84.346 81.4219C83.2321 80.308 83.2321 78.5021 84.346 77.3882L85.658 78.7002ZM87.0676 80.1098L88.9765 78.2009L90.2885 79.513L88.3797 81.4219L87.0676 80.1098ZM92.0104 77.7911L90.2885 79.513L88.9765 78.2009L90.6984 76.4791L92.0104 77.7911ZM84.4388 62.4261L90.561 66.2661L89.5751 67.838L83.4529 63.998L84.4388 62.4261ZM91.4228 67.1179L93.8282 70.8564L92.2678 71.8603L89.8624 68.1219L91.4228 67.1179ZM77.8224 65.7062L77.3305 67.4106L75.5477 66.8961L76.0396 65.1917L77.8224 65.7062ZM77.0027 68.1359L74.985 71.2985L73.4208 70.3005L75.4385 67.1379L77.0027 68.1359ZM77.3304 67.4106C77.2565 67.6668 77.1461 67.9111 77.0027 68.1358L75.4385 67.1379C75.4863 67.0629 75.5231 66.9815 75.5477 66.8961L77.3304 67.4106ZM90.561 66.2661C90.9073 66.4833 91.2016 66.7741 91.4228 67.1179L89.8624 68.1219C89.7886 68.0073 89.6906 67.9104 89.5751 67.838L90.561 66.2661ZM92.6106 76.8956C92.4708 77.2304 92.2669 77.5346 92.0104 77.7911L90.6984 76.4791C90.7839 76.3936 90.8519 76.2922 90.8985 76.1806L92.6106 76.8956ZM92.3437 72.7199C92.4613 72.4383 92.4329 72.1169 92.2678 71.8603L93.8282 70.8564C94.3235 71.6261 94.4086 72.5902 94.0559 73.4349L92.3437 72.7199ZM82.215 62.1023C82.9688 61.8929 83.776 62.0104 84.4388 62.4261L83.4529 63.998C83.2319 63.8595 82.9629 63.8203 82.7116 63.8901L82.215 62.1023ZM76.163 73.4252C76.5289 73.7628 77.0961 73.7515 77.4482 73.3994L78.7602 74.7114C77.704 75.7676 76.0024 75.8017 74.9046 74.7887L76.163 73.4252ZM73.8796 73.8428C72.8892 72.9289 72.6959 71.4366 73.4208 70.3005L74.985 71.2985C74.7434 71.6772 74.8078 72.1746 75.1379 72.4792L73.8796 73.8428ZM78.4654 65.0695C78.1551 65.1557 77.9117 65.3967 77.8224 65.7062L76.0396 65.1917C76.3076 64.2633 77.0378 63.5404 77.9688 63.2818L78.4654 65.0695Z",
    fill: "#DDA34E",
    id: "path3",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3864 74.107L31.4114 73.161C32.0717 72.5517 32.2005 71.5569 31.7173 70.7995L29.6996 67.6369C29.6039 67.487 29.5304 67.3242 29.4811 67.1534L28.9892 65.4489C28.8106 64.83 28.3237 64.3481 27.7031 64.1756L23.4569 62.9962C22.9543 62.8566 22.4162 62.9349 21.9744 63.2121L15.8521 67.052C15.6212 67.1969 15.4251 67.3907 15.2776 67.6199L12.8722 71.3584C12.542 71.8715 12.4852 72.5143 12.7204 73.0774L14.1656 76.5381C14.2588 76.7613 14.3948 76.9641 14.5658 77.1351L16.2876 78.857L18.1965 80.7659C18.9481 81.5174 20.1666 81.5174 20.9182 80.7659C21.6697 80.0143 21.6697 78.7958 20.9182 78.0442L21.6004 78.7264C22.3519 79.478 23.5705 79.478 24.322 78.7264C25.0736 77.9748 25.0736 76.7563 24.322 76.0047L24.546 76.2287C25.2976 76.9803 26.5161 76.9803 27.2677 76.2287C28.0192 75.4771 27.5161 73.7555 26.7645 73.0039L27.816 74.0554C28.5201 74.7595 29.6545 74.7823 30.3864 74.107Z",
    fill: "#F8F8F8",
    id: "path4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.4114 73.161L30.7822 72.4792L30.7822 72.4792L31.4114 73.161ZM30.3864 74.107L31.0155 74.7887L31.0155 74.7887L30.3864 74.107ZM25.1086 70.036C24.7463 69.6737 24.1589 69.6737 23.7966 70.036C23.4343 70.3983 23.4343 70.9857 23.7966 71.348L25.1086 70.036ZM27.7031 64.1756L27.9514 63.2818L27.9514 63.2818L27.7031 64.1756ZM23.4569 62.9962L23.7052 62.1023L23.7052 62.1023L23.4569 62.9962ZM12.7204 73.0774L11.8643 73.4349L12.7204 73.0774ZM14.1656 76.5381L15.0217 76.1806L15.0217 76.1806L14.1656 76.5381ZM22.387 72.7576C22.0246 72.3953 21.4372 72.3953 21.0749 72.7576C20.7126 73.1199 20.7126 73.7074 21.0749 74.0697L22.387 72.7576ZM19.6653 75.4793C19.303 75.117 18.7156 75.117 18.3533 75.4793C17.991 75.8416 17.991 76.429 18.3533 76.7913L19.6653 75.4793ZM16.2876 78.857L16.9436 78.2009L16.9436 78.2009L16.2876 78.857ZM14.5658 77.1351L13.9098 77.7911L13.9098 77.7911L14.5658 77.1351ZM21.9744 63.2121L22.4673 63.998L21.9744 63.2121ZM15.8521 67.052L15.3591 66.2661L15.8521 67.052ZM15.2776 67.6199L14.4974 67.1179L14.4974 67.1179L15.2776 67.6199ZM12.8722 71.3584L13.6524 71.8603L12.8722 71.3584ZM28.9892 65.4489L28.0978 65.7062L28.0978 65.7062L28.9892 65.4489ZM29.4811 67.1534L28.5897 67.4106L28.5897 67.4106L29.4811 67.1534ZM29.6996 67.6369L28.9174 68.1358L28.9174 68.1359L29.6996 67.6369ZM31.7173 70.7995L30.9352 71.2985L30.9352 71.2985L31.7173 70.7995ZM30.7822 72.4792L29.7572 73.4252L31.0155 74.7887L32.0406 73.8428L30.7822 72.4792ZM28.472 73.3994L27.4205 72.3479L26.1085 73.6599L27.16 74.7114L28.472 73.3994ZM27.4205 72.3479L25.1086 70.036L23.7966 71.348L26.1085 73.6599L27.4205 72.3479ZM27.9514 63.2818L23.7052 62.1023L23.2086 63.8901L27.4548 65.0695L27.9514 63.2818ZM11.8643 73.4349L13.3095 76.8956L15.0217 76.1806L13.5765 72.7199L11.8643 73.4349ZM25.202 75.5727L24.978 75.3487L23.666 76.6607L23.89 76.8847L25.202 75.5727ZM24.978 75.3487L22.387 72.7576L21.0749 74.0697L23.666 76.6607L24.978 75.3487ZM26.6116 75.5727C26.2224 75.9619 25.5913 75.9619 25.202 75.5727L23.89 76.8847C25.0039 77.9986 26.8098 77.9986 27.9237 76.8847L26.6116 75.5727ZM26.1085 73.6599C26.334 73.8854 26.5746 74.3291 26.6706 74.8012C26.7737 75.308 26.6571 75.5273 26.6116 75.5727L27.9237 76.8847C28.6298 76.1786 28.6373 75.1612 28.4889 74.4314C28.3334 73.6669 27.9466 72.8739 27.4205 72.3479L26.1085 73.6599ZM22.2564 78.0704L21.5742 77.3882L20.2622 78.7002L20.9444 79.3824L22.2564 78.0704ZM21.5742 77.3882L19.6653 75.4793L18.3533 76.7913L20.2622 78.7002L21.5742 77.3882ZM23.666 78.0704C23.2768 78.4596 22.6456 78.4596 22.2564 78.0704L20.9444 79.3824C22.0582 80.4963 23.8642 80.4963 24.978 79.3824L23.666 78.0704ZM23.666 76.6607C24.0553 77.05 24.0553 77.6811 23.666 78.0704L24.978 79.3824C26.0919 78.2685 26.0919 76.4626 24.978 75.3487L23.666 76.6607ZM20.2622 80.1098C19.8729 80.4991 19.2418 80.4991 18.8525 80.1098L17.5405 81.4219C18.6544 82.5357 20.4603 82.5357 21.5742 81.4219L20.2622 80.1098ZM20.2622 78.7002C20.6514 79.0895 20.6514 79.7206 20.2622 80.1098L21.5742 81.4219C22.6881 80.308 22.6881 78.5021 21.5742 77.3882L20.2622 78.7002ZM18.8525 80.1098L16.9436 78.2009L15.6316 79.513L17.5405 81.4219L18.8525 80.1098ZM13.9098 77.7911L15.6316 79.513L16.9436 78.2009L15.2218 76.4791L13.9098 77.7911ZM21.4814 62.4261L15.3591 66.2661L16.345 67.838L22.4673 63.998L21.4814 62.4261ZM14.4974 67.1179L12.092 70.8564L13.6524 71.8603L16.0578 68.1219L14.4974 67.1179ZM28.0978 65.7062L28.5897 67.4106L30.3724 66.8961L29.8805 65.1917L28.0978 65.7062ZM28.9174 68.1359L30.9352 71.2985L32.4994 70.3005L30.4817 67.1379L28.9174 68.1359ZM28.5897 67.4106C28.6637 67.6668 28.774 67.9111 28.9174 68.1358L30.4817 67.1379C30.4339 67.0629 30.3971 66.9815 30.3724 66.8961L28.5897 67.4106ZM15.3591 66.2661C15.0128 66.4833 14.7186 66.7741 14.4974 67.1179L16.0578 68.1219C16.1315 68.0073 16.2296 67.9104 16.345 67.838L15.3591 66.2661ZM13.3095 76.8956C13.4493 77.2304 13.6532 77.5346 13.9098 77.7911L15.2218 76.4791C15.1363 76.3936 15.0683 76.2922 15.0217 76.1806L13.3095 76.8956ZM13.5765 72.7199C13.4589 72.4383 13.4873 72.1169 13.6524 71.8603L12.092 70.8564C11.5967 71.6261 11.5116 72.5902 11.8643 73.4349L13.5765 72.7199ZM23.7052 62.1023C22.9513 61.8929 22.1442 62.0104 21.4814 62.4261L22.4673 63.998C22.6882 63.8595 22.9573 63.8203 23.2086 63.8901L23.7052 62.1023ZM29.7572 73.4252C29.3913 73.7628 28.8241 73.7515 28.472 73.3994L27.16 74.7114C28.2162 75.7676 29.9178 75.8017 31.0155 74.7887L29.7572 73.4252ZM32.0406 73.8428C33.031 72.9289 33.2243 71.4366 32.4994 70.3005L30.9352 71.2985C31.1768 71.6772 31.1124 72.1746 30.7822 72.4792L32.0406 73.8428ZM27.4548 65.0695C27.7651 65.1557 28.0085 65.3967 28.0978 65.7062L29.8805 65.1917C29.6126 64.2633 28.8824 63.5404 27.9514 63.2818L27.4548 65.0695Z",
    fill: "#DDA34E",
    id: "path5",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4336 70.5904V71.4434H53.2866C58.4786 71.4434 61.3587 69.9714 63.5437 68.4731C63.918 68.2165 64.2518 67.9782 64.5522 67.7638L64.5543 67.7623C65.9862 66.7403 66.6006 66.3251 67.7886 66.3251C69.3843 66.3251 70.656 66.8101 71.8871 67.5264C72.5235 67.8966 73.1279 68.3156 73.7903 68.7796L73.8808 68.8431L73.8868 68.8472C74.2985 69.1358 74.7433 69.4475 75.2012 69.7434C75.855 70.166 76.6556 70.2091 77.3404 69.9319C78.2153 69.5778 78.7692 68.7079 78.7199 67.7654L78.7165 67.6992C78.672 66.8475 78.2014 66.107 77.5315 65.6611C77.2196 65.4534 76.8939 65.2254 76.5314 64.9713L76.0419 65.67L76.5314 64.9713L76.4822 64.9369L76.4821 64.9369C75.8314 64.481 75.0763 63.9537 74.2466 63.471C72.5456 62.4813 70.4583 61.6333 67.7886 61.6333C64.9796 61.6333 63.1138 62.9933 61.6754 64.0418L61.6351 64.0712C61.3722 64.2628 61.1286 64.4403 60.8904 64.6036C59.3435 65.6643 57.3718 66.7516 53.2866 66.7516H52.4336V67.6047V70.5904Z",
    fill: "#DDA34E",
    stroke: "#DDA34E",
    strokeWidth: 1.70611,
    id: "path6",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6997 70.5904V71.4434H52.8467C47.6547 71.4434 44.7746 69.9714 42.5896 68.4731C42.2154 68.2165 41.8815 67.9782 41.5811 67.7638L41.579 67.7623C40.1471 66.7403 39.5327 66.3251 38.3447 66.3251C36.749 66.3251 35.4773 66.8101 34.2462 67.5264C33.6098 67.8966 33.0054 68.3156 32.343 68.7796L32.2525 68.8431L32.2465 68.8472C31.8348 69.1358 31.39 69.4475 30.9321 69.7434C30.2783 70.166 29.4777 70.2091 28.7929 69.9319C27.918 69.5778 27.3641 68.7079 27.4134 67.7654L27.4168 67.6992C27.4613 66.8475 27.9319 66.107 28.6018 65.6611C28.9137 65.4534 29.2394 65.2254 29.6019 64.9713L30.0914 65.67L29.6019 64.9713L29.6511 64.9369L29.6512 64.9369C30.3019 64.481 31.057 63.9537 31.8867 63.471C33.5877 62.4813 35.675 61.6333 38.3447 61.6333C41.1537 61.6333 43.0195 62.9933 44.4579 64.0418L44.4982 64.0712C44.7611 64.2628 45.0047 64.4403 45.2429 64.6036C46.7898 65.6643 48.7615 66.7516 52.8467 66.7516H53.6997V67.6047V70.5904Z",
    fill: "#DDA34E",
    stroke: "#DDA34E",
    strokeWidth: 1.70611,
    id: "path7",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1305 31.8888V35.1839C69.1305 35.4118 69.344 35.5823 69.5715 35.5942C71.1859 35.679 73.3499 37.8492 70.911 40.6133C69.439 42.2816 67.528 40.9694 67.1719 40.7913C64.5041 46.4889 61.3419 54.83 53.106 54.83C46.1729 54.83 41.7078 46.4889 39.04 40.7913C38.6839 40.9694 36.4168 42.0159 34.9448 40.3476C32.5021 37.5792 34.9745 35.4106 36.6406 35.3329C36.8681 35.3223 37.0814 35.1509 37.0814 34.9231V31.8888C37.3188 30.7612 40.8561 25.1538 53.106 25.1538C65.3558 25.1538 68.8931 30.7612 69.1305 31.8888Z",
    fill: "#F8F8F8",
    id: "path8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.4872 35.8562C35.8847 35.5001 32.6798 37.8099 35.3506 40.8368C36.8226 42.5051 38.7335 41.1929 39.0896 41.0148C41.7574 51.1818 49.798 54.8301 53.1556 54.8301C56.5132 54.8301 64.5538 51.1818 67.2216 41.0148C67.5777 41.1929 69.4886 42.5051 70.9606 40.8368C73.6314 37.8099 70.4265 35.5001 68.824 35.8562M74.3363 26.5546C74.3363 13.8694 65.8407 6.49121 53.1556 6.49121C40.4704 6.49121 31.9749 13.8694 31.9749 26.5546C31.9749 27.7323 32.0635 28.8894 32.2345 30.0194C32.5471 32.0854 35.017 34.499 36.5379 35.8562C36.7674 36.061 37.1311 35.8981 37.1311 35.5905L37.1311 32.1123C37.3685 30.9847 40.9057 24.9304 53.1556 24.9304C65.4055 24.9304 68.9427 30.9847 69.1801 32.1123V35.3671C69.1801 35.7041 69.6047 35.8526 69.8147 35.5891L72.504 32.2139C73.2122 31.325 73.7498 30.3044 74.0375 29.2049C74.2341 28.4535 74.3363 27.8193 74.3363 26.5546Z",
    stroke: "#DDA34E",
    strokeWidth: 2.1366,
    id: "path9",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2344 35.2053V36.4517",
    stroke: "#DDA34E",
    strokeWidth: 2.73365,
    strokeLinecap: "round",
    id: "path10",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9336 35.2053V36.4517",
    stroke: "#DDA34E",
    strokeWidth: 2.73365,
    strokeLinecap: "round",
    id: "path11",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.308 46.4111V46.4111C54.1435 46.9404 52.8071 46.9404 51.6426 46.4111V46.4111",
    stroke: "#DDA34E",
    strokeWidth: 2.0381,
    strokeLinecap: "round",
    id: "path12",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8794 39.1082L52.4229 36.2784C52.8333 35.526 53.918 35.5388 54.3105 36.3007L55.7799 39.153C56.136 39.8444 55.8903 40.6936 55.2199 41.0879L54.6163 41.443C53.8551 41.8908 52.9138 41.9024 52.1418 41.4735L51.4544 41.0916C50.7506 40.7006 50.4939 39.815 50.8794 39.1082Z",
    fill: "#DDA34E",
    id: "path13",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7705 6.7146L52.0375 13.3353C52.0696 14.131 52.724 14.7595 53.5204 14.7595V14.7595C54.3167 14.7595 54.9711 14.131 55.0032 13.3353L55.2702 6.7146",
    stroke: "#DDA34E",
    strokeWidth: 1.78776,
    id: "path14",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8533 9.28457L43.8786 15.8531C44.1285 16.6636 44.9746 17.1313 45.7938 16.9118V16.9118C46.6134 16.6922 47.1123 15.8634 46.9228 15.0363L45.2522 7.74384",
    stroke: "#DDA34E",
    strokeWidth: 1.78776,
    id: "path15",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8381 7.83185L60.1877 15.0362C59.9982 15.8632 60.4972 16.692 61.3168 16.9116V16.9116C62.1359 17.1311 62.982 16.6634 63.2319 15.853L65.2573 9.28441",
    stroke: "#DDA34E",
    strokeWidth: 1.78776,
    id: "path16",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3537 13.1952L67.4427 18.9373C67.078 19.6566 67.3394 20.5356 68.0379 20.9389V20.9389C68.7335 21.3405 69.6215 21.1309 70.0642 20.4607L72.575 16.6589",
    stroke: "#DDA34E",
    strokeWidth: 1.78776,
    id: "path17",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8778 13.0834L39.8454 18.9372C40.2101 19.6566 39.9488 20.5356 39.2503 20.9389V20.9389C38.5547 21.3405 37.6666 21.1309 37.224 20.4606L34.5656 16.4354",
    stroke: "#DDA34E",
    strokeWidth: 1.78776,
    id: "path18",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0085 25.7097C39.6573 23.5293 43.9457 21.0168 53.2045 21.0168C62.4633 21.0168 66.7517 23.5293 68.4004 25.7097",
    stroke: "#DDA34E",
    strokeWidth: 2.1366,
    strokeLinecap: "round",
    id: "path19",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5481 30.8494L41.0063 45.3749",
    stroke: "#DDA34E",
    strokeWidth: 2.23662,
    strokeLinecap: "round",
    id: "path20",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7166 30.8494L66.2584 45.3749",
    stroke: "#DDA34E",
    strokeWidth: 2.23662,
    strokeLinecap: "round",
    id: "path21",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.1746,
    cy: 28.1678,
    r: 0.893879,
    fill: "#DDA34E",
    id: "circle21",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8665,
    cy: 28.1678,
    r: 0.893879,
    fill: "#DDA34E",
    id: "circle22",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6648 64.3049H52.8224H50.9934C50.9173 64.3049 50.8418 64.3233 50.7712 64.3589L49.7165 64.8915C49.511 64.9952 49.3677 65.2337 49.3439 65.5114L48.8233 71.5897C48.7993 71.8696 48.9007 72.143 49.0862 72.2992L50.3126 73.3312C50.4791 73.4713 50.579 73.707 50.579 73.9595V86.2083C50.579 86.5343 50.8433 86.7985 51.1693 86.7985H54.5142C54.8402 86.7985 55.1045 86.5343 55.1045 86.2083V73.8301C55.1045 73.6559 55.1814 73.4907 55.3147 73.3785L56.6651 72.2422C56.8119 72.1186 56.8895 71.9314 56.8731 71.7402L56.3291 65.3882C56.3116 65.1842 56.1897 65.0039 56.007 64.9116L54.9308 64.3683C54.8484 64.3266 54.7572 64.3049 54.6648 64.3049Z",
    fill: "#DDA34E",
    stroke: "#DDA34E",
    strokeWidth: 1.77074,
    id: "path22",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1499 27.8625C15.9182 26.226 5.41272 26.9734 5.41272 33.7337C5.41272 41.032 11.8164 42.9223 16.6472 40.2275C21.827 37.3381 18.3191 19.2168 9.44393 15.0623",
    stroke: "#DDA34E",
    strokeWidth: 2.9857,
    strokeLinecap: "round",
    strokeDasharray: "3.63 5.76",
    id: "path23",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3703 55.2844C99.0858 54.7138 97.0317 47.1639 91.0226 50.8825C86.1217 53.9152 83.4144 51.6175 80.0227 47.3647C77.5796 44.3015 80.5551 42.4057 78.7151 39.9355",
    stroke: "#DDA34E",
    strokeWidth: 2.9857,
    strokeLinecap: "round",
    strokeDasharray: "1.49 5.54",
    id: "path24",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2523 10.6632C97.9774 18.3636 91.8598 20.9464 81.941 23.6041",
    stroke: "#DDA34E",
    strokeWidth: 2.9857,
    strokeLinecap: "round",
    strokeDasharray: "1.49 5.54",
    id: "path25",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0509 55.2934C19.2576 55.6348 19.7058 55.7475 20.0201 55.5015C21.2011 54.577 21.7799 53.3827 21.3328 52.6444C20.9905 52.0792 20.1329 51.9229 19.1365 52.1581C19.8065 51.384 20.0655 50.5516 19.7232 49.9864C19.2761 49.2481 17.9495 49.2077 16.5831 49.8259C16.2194 49.9904 16.1116 50.4397 16.3184 50.7811L17.8156 53.2536C17.8156 53.2536 17.8157 53.2536 17.8157 53.2536L19.0509 55.2934Z",
    fill: "#DDA34E",
    id: "path26",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1803 52.5064C11.9736 52.165 11.5254 52.0523 11.2111 52.2983C10.0301 53.2228 9.45129 54.4171 9.89839 55.1554C10.2407 55.7206 11.0983 55.8769 12.0947 55.6417C11.4247 56.4158 11.1657 57.2482 11.508 57.8134C11.9551 58.5517 13.2817 58.5922 14.6481 57.9739C15.0118 57.8094 15.1196 57.3601 14.9128 57.0187L13.4156 54.5462C13.4156 54.5462 13.4156 54.5462 13.4155 54.5462L12.1803 52.5064Z",
    fill: "#DDA34E",
    id: "path27",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1,
      fill: "#62c8d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2218 50.1963C15.0558 52.5024 15.6429 54.4654 17.6013 57.4284",
    stroke: "#DDA34E",
    strokeWidth: 1.70611,
    strokeLinecap: "round",
    id: "path28",
    style: {
      stroke: "#62c8d3",
      strokeOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_6444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.632,
    height: 85.3057,
    fill: "white",
    transform: "translate(0.183838)",
    id: "rect28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLts2);
export default __webpack_public_path__ + "static/media/Icon_LTS2.0590313b4c1397867e940c74040eab6b.svg";
export { ForwardRef as ReactComponent };